import { IModalInjectProps } from '@monorepo/controlled/src/components/modal/modal/modal';
import { Icon } from '@monorepo/base/src/components/icon/icon';
import { Card } from '@monorepo/base/src/components/card/card';

export const DestinationGuardModal = ({
	message,
	onClose,
	closeModal,
}: { message: string; onClose: () => void } & Partial<IModalInjectProps>) => {
	const dismiss = () => {
		onClose();
		closeModal?.();
	};

	return (
		<Card>
			<div style={{ position: 'relative', padding: '8px 8px 4px' }}>
				<button
					type="button"
					aria-label="Close"
					onClick={dismiss}
					style={{ position: 'absolute', top: 0, right: 0, border: 'none', background: 'transparent', cursor: 'pointer' }}>
					<Icon isMFP size="20px">
						x
					</Icon>
				</button>
				<h3>Cannot pause destination</h3>
				<p>{message}</p>
			</div>
		</Card>
	);
};
